import { SignupEmbedderOptions } from 'signup-embedder';
export const getQueryParamsNoEmbedderOptions = queryParams => {
  return Object.keys(queryParams).reduce((acc, key) => {
    const isNotSignupEmbedderOption = !SignupEmbedderOptions.protectedOptions.has(key);
    if (isNotSignupEmbedderOption) {
      acc[key] = queryParams[key];
    }
    return acc;
  }, {});
};